import { gpHome } from '../../app';
import { Report } from '../../services/analysis-contract';
import analysisReportTemplate from './analysis-report.html';

class AnalysisReportComponent {

    report!: Report;

    print(): void {
        window.print();
    }
}

gpHome.component('gpAnalysisReport', {
    template: analysisReportTemplate,
    controller: AnalysisReportComponent,
    bindings: {
        report: '<',
    },
});
